import { GuardData } from './guard.model';

const guestGuard = (guardData: GuardData): boolean => {
  return !guardData.store.auth.user;
};

export default guestGuard;